<template>
  <div>
    <MainSalary title="GAJI POKOK PEGAWAI KONTRAK PEMDA" type="pemda" />
  </div>
</template>

<script>
import MainSalary from '@/components/salary/main.vue'

export default {
	middleware: 'auth',
  components: { MainSalary },
}
</script>
